import { splitUid, getUid, getMemberKeys } from 'Services/WeaverUtils'
import {
  setFilteredNodesByGraph
  setFilteredNodesByRelation
  setFilteredNodesByType
  setFilteredRelationsByKey
} from 'Actions/graphFilter'
import { store } from '~/Store'
import { getRelevantEntityIdFromString, getRelevantEntityIdFromNode } from 'Pages/Explore/RightPanel/GraphView/Utils'


export flatMapUnique = _.flow(_.flatMap, _.uniq)
getNodeIds = (nodes) -> _.map(nodes, ({ wvrId }, _) -> splitUid(wvrId)[0])

export filterNodesByGraph = ->
  { graph: { graphData: { nodes }}, graphFilter: { graphFilters }} = store.getState()
  nodesToDisable = []
  disabledGraphs = _.map(_.filter(graphFilters, ['enabled', false]), 'id')

  if disabledGraphs.length > 0
    nodesToDisable = _.map(_.filter(nodes, (node) ->
      node.graph in disabledGraphs
    ), 'id')

  setFilteredNodesByGraph(nodesToDisable)

export filterNodesByType = ->
  { graph: { graphData: { nodes }}, graphFilter: { typeFilters }} = store.getState()
  nodeIds = getNodeIds(nodes)
  nodesToDisable = []

  disabledTypes = _.map(_.filter(typeFilters, ['enabled', false]), (item) -> getUid(item))

  if _.size(disabledTypes) > 0
    q = new Weaver.Query()
      .restrict(nodeIds)
      .hasRelationOut(getMemberKeys())

    nodesToDisable = _.reduce(await q.withAttributes().withRelations().setMetaNodesQuery(new Weaver.Query().selectIn('*').selectOut('*')).find(), (acc, node) ->
      for memberKey in getMemberKeys()
        for record in node.relation(memberKey)._records

          if ((getUid(record.fromNode) not in disabledTypes) and (getUid(record.toNode) not in disabledTypes))
            return acc
          else
            attEntityIds = []
            attributes = _.values(node._attributes)
            attributes.map(({ _records }) ->
              _records.map(({ attNode }) ->
                attEntityIds.push(getRelevantEntityIdFromNode(attNode))
                attEntityIds.push(getRelevantEntityIdFromString('attribute-value', getUid(attNode)))
              )
            )

            relEntityIds = []
            relations = _.values(node._relations)
            relations.map(({ _records }) ->
              _records.map(({ relNode }) ->
                relEntityIds.push(getRelevantEntityIdFromNode(relNode))
              )
            )

            nodeEntityIds = [
              getRelevantEntityIdFromNode(record.fromNode),
              getRelevantEntityIdFromNode(record.toNode)
            ]

          return [
            acc...,
            attEntityIds...,
            relEntityIds...,
            nodeEntityIds...
          ]
    , [])

  setFilteredNodesByType([nodesToDisable..., disabledTypes...])

export filterNodesByRelation = ->
  { graph: { graphData: { edges }}, graphFilter: { relationFilters }} = store.getState()
  nodesToDisable = []
  nodesToCheck = []
  disabledRelations = _.map(_.filter(relationFilters, ['enabled', false]), 'key')

  if disabledRelations.length > 0
    nodesToCheck = _(edges)
      .filter((edge) -> _.includes(disabledRelations, edge.key))
      .map((edge) -> edge.to)
      .value()

  nodesToDisable = _.reduce(nodesToCheck, (acc, node) ->
    hasVisibleRelations = _.some edges, (edge) ->
      edge.key not in disabledRelations and (edge.to is node)

    if hasVisibleRelations then acc else [...acc, node]
  , [])

  setFilteredNodesByRelation(nodesToDisable)

export filterRelationsByKey = ->
  {
    graph: {
      graphData: {
        edges
      }
    }
    graphFilter: {
      filteredNodes
      relationFilters
    }
  } = store.getState()

  filteredNodes = flatMapUnique(filteredNodes)
  disabledRelations = _.map(_.filter(relationFilters, ['enabled', false]), 'key')

  setFilteredRelationsByKey(
    _.uniq(
      _.reduce(_.filter(edges, (edge) ->
        edge.key in disabledRelations or
        edge.from in filteredNodes or
        edge.to in filteredNodes
      ), (acc, edge) ->
        [
          acc...
          edge._id
          edge.id
        ]
      , [])
    )
  )

export getGraphs = ({ selectedItems }) ->
  { graph: { graphData: { nodes }}} = store.getState()
  graphs = _.uniq(_.keys(nodes).map((id) -> splitUid(id)[1]))
  defaultGraph = graphs.find((graph) -> graph is undefined)

  _.reduce(graphs, (acc, graph, count) ->
    id = graph
    res = { acc... }
    if id is undefined
      res.default = {
        enabled: if item = selectedItems.find((item) -> item.id is undefined) then item.enabled else true
        id: undefined
        label: 'Default Graph'
      }
    else
      res[id] = {
        id
        enabled: if item = selectedItems.find((item) -> item.id is id) then item.enabled else true
        label: id
      }
    res
  , {})

parseFilteredTypesList = (types, selectedItems) ->
  types.reduce((acc, { id, graph, label }) ->
    id = getUid(id, graph)
    {
      acc...
      [id]: {
        id
        enabled: if item = selectedItems.find((item) -> item.id is id) then item.enabled else true
        label
      }
    }
  , {})

export getFilteredTypes = ({ nodes, memberKeys, selectedItems, types }) ->
  nodeIds = _.map(nodes, (_, id) -> splitUid(id)[0])
  types = types.filter(({ id, graph }) -> nodes[getRelevantEntityIdFromString('node', getUid(id, graph))])
  parseFilteredTypesList(types, selectedItems)
